// src/redux/reducers/riskReducer.js

import { 
  INITIALIZE_MODEL,
  FETCH_MODELS_START, 
  FETCH_MODELS_SUCCESS, 
  FETCH_MODELS_FAILURE,
  FETCH_MODEL_RISKS_SUCCESS,
  DELETE_MODEL,
  SET_SECTION,
  SET_ASSESSMENT_POSITION,
  SET_STEP,
  UPDATE_ASSESSMENT_STEP_SUCCESS,
  UPDATE_ASSESSMENT_STEP_FAILURE,
  SET_MODEL_ID,
  DISCARD_RISKS,
  DISCARD_UNSAVED_RISKS,
  REFINE_RISK_START,
  REFINE_RISK_SUCCESS,
  REFINE_RISK_FAILURE,
  UPDATE_RISK_NAME,
  FETCH_RISKS_START, 
  FETCH_RISKS_FAILURE, 
  SET_RISK_EVALUATION,
  UPDATE_RISK_PRIORITY,
  UPDATE_RISK_EVALUATION,
  UPDATE_CONTROL_IN_SELECTED_RISK,
  FETCH_RISK_CARD_DATA_START, 
  FETCH_RISK_CARD_DATA_SUCCESS, 
  FETCH_RISK_CARD_DATA_FAILURE, 
  FETCH_RISK_EVALUATIONS, 
  FETCH_RISK_EVALUATIONS_SUCCESS,
  FETCH_RISK_EVALUATIONS_FAILURE,
  UPDATE_ACTIVE_SECTIONS_FROM_SAVED_RISKS,
  MOVE_RISK_TO_SAVED,
  UPDATE_SAVED_RISK,
  DISCARD_SAVED_RISK,
  RESET_RISKS_STATE,
  FETCH_SECTION_SPECIFIC_RISKS_START,
  FETCH_SECTION_SPECIFIC_RISKS_SUCCESS,
  FETCH_SECTION_SPECIFIC_RISKS_FAILURE,
  ASSESSMENT_STATUS_UPDATED,
  ASSESSMENT_STATUS_FAILED,
  REFRESH_RISKS_SUCCESS,
  SET_RISK_PRIORITY_START,
  SET_RISK_PRIORITY_SUCCESS,
  SET_RISK_PRIORITY_FAILURE,
  UPDATE_LOADING_MESSAGE,
  UPDATE_SECTION_PROGRESS,
  //UPDATE_CAUSE_FIELD,
  SAVE_RISK_SOURCE_START,
  SAVE_RISK_SOURCE_SUCCESS,
  SAVE_RISK_SOURCE_FAILURE,
  SAVE_CAUSES_START,
  SAVE_CAUSES_SUCCESS,
  SAVE_CAUSES_FAILURE,
  // INITIALIZE_DRAFT_RISKS, // Legacy - removed
  SET_CURRENT_SECTION,
  SET_CURRENT_SECTION_STEP,
  RESET_CURRENT_SECTION_STEP,
  CONFIG_UPDATE_SUCCESS, 
  CONFIG_UPDATE_FAILURE,
  ADD_MANUAL_RISK,
  SET_RISK_SOURCE,
  SET_ROOT_CAUSE,
  SET_DEEP_DIVE_DETAIL,
  SET_DEEP_DIVE_VALUES,
  GENERATE_RISK_NARRATIVE_START,
  GENERATE_RISK_NARRATIVE_SUCCESS,
  GENERATE_RISK_NARRATIVE_FAILURE,
  SELECT_RISK_SOURCE,
  DESELECT_RISK_SOURCE,
   MOVE_SCENARIO_TO_RISKS,
   REGISTER_RISK_SOURCES,
  TOGGLE_RISK_SOURCE,
  SET_RISK_SOURCE_PROGRESS,
  // New area-based actions
  SET_AREA_STATUS,
  SET_AREA_DEFERRED,
  SET_AREA_NOT_APPLICABLE,
  CLEAR_AREA_STATUS
} from '../actions/actionTypes.js';
   
import { mergeRiskSources, mergeRiskRootCauses, mergeRiskCauseEvaluation } from '../reduxutils/riskFormUtils.js';
import { v4 as uuidv4 } from 'uuid';
// Removed evaluationForm import - now using state.configs.riskEvaluationForm
import _ from 'lodash';

  


const initialState = {
  models: {},
  modelsLoading: false,
  loadingMessage: ''
};


const initializeModel = (modelId, modelName, modelType, modelStage, useCaseShortDescription, created_at, created_by, avatar, createdByName, assessmentUuid, assessmentStatus, currentStep, riskFormData, state) => {
  if (modelId && !state.models[modelId]) {
    // Use evaluation form from configs state if available, fallback to empty array
    const evaluationCriteria = state.config?.configs?.riskEvaluationForm || [];
    //const initializedRiskForm = _.cloneDeep(riskForm);

    return {
      ...state,
      models: {
        ...state.models,
        [modelId]: {
          modelName,
          modelType,
          modelStage,
          useCaseShortDescription,
          created_at,
          created_by,
          avatar,
          createdByName,
          assessmentUuid,
          assessmentStatus,
          riskFormData,
          activeSections: [],
          sectionLoading: {},
          selectedRisks: [],
          risks: [],
          selectedThemes: [],
          discardedRisks: [],
          savedRisks: state.models[modelId]?.savedRisks?.map(risk => ({
            ...risk,
            evaluationData: risk.evaluationData || evaluationCriteria,
            selectedControls: risk.selectedControls || []
          })) || [],
          loading: false,
          error: null,
          step: currentStep || 'Not Started',
          position: { majorStep: currentStep || 'useCase' },

        },
      },
    };
  }
  return state;
}

const riskReducer = (state = initialState, action) => {
  switch (action.type) {

    case RESET_RISKS_STATE:
      return initialState;

    case FETCH_MODELS_START:
      return {
        ...state,
        modelsLoading: true,
        loadingMessage: 'Fetching models...'
      };

    


    case FETCH_MODELS_SUCCESS: {
      const { models } = action.payload;
    
      let newState = { ...state, modelsLoading: false, loadingMessage: '' };
      models.forEach(model => {
        if (!newState.models[model.model_uuid]) {
          newState = initializeModel(
            model.model_uuid,              
            model.model_name,
            model.model_type,
            model.model_stage,
            model.use_case_short_description,
            model.created_at,
            model.created_by,
            model.avatar,
            model.name,
            model.assessment_uuid,
            model.assessment_status,
            model.current_step || 'Not Started',
            action.payload.riskFormData,
            newState
          );
        }
      });
    
      return newState;
    }

    case FETCH_MODELS_FAILURE:
      return {
        ...state,
        modelsLoading: false,
        loadingMessage: 'Failed to load data.'
      };

    case INITIALIZE_MODEL: {
      const { modelId, modelName, modelType, modelStage, useCaseShortDescription, created_at, created_by, avatar, createdByName,assessmentUuid, assessmentStatus, currentStep, riskFormData } = action.payload;
      return initializeModel(modelId, modelName, modelType, modelStage,useCaseShortDescription,created_at,created_by, avatar, createdByName,assessmentUuid, assessmentStatus, currentStep,riskFormData, state);
    }

    case DELETE_MODEL: {
      const modelId = action.payload;
      const newModels = { ...state.models };
      delete newModels[modelId];
      return {
        ...state,
        models: newModels,
      };
    }

    

    case SET_MODEL_ID: {
      const {
        modelId,
        modelName,
        modelType,
        modelStage,
        useCaseShortDescription,
        created_at,
        created_by,
        avatar,
        createdByName,
        assessmentUuid,
        assessmentStatus,
        currentStep,
        riskFormData
      } = action.payload;
      
      console.log('SET_MODEL_ID action payload:', action.payload);
      
      let newState = { ...state };
      
      if (modelId) {
        if (!newState.models[modelId]) {
          // Model doesn't exist yet, initialize it
          newState = initializeModel(
            modelId,
            modelName,
            modelType,
            modelStage,
            useCaseShortDescription,
            created_at,
            created_by,
            avatar,
            createdByName,
            assessmentUuid,
            assessmentStatus,
            currentStep,
            riskFormData,
            newState
          );
        } else {
          // Model exists, just update the fields
          const existingModel = newState.models[modelId];
          newState.models[modelId] = {
            ...existingModel,
            modelName: modelName || existingModel.modelName,
            modelType: modelType || existingModel.modelType,
            modelStage: modelStage || existingModel.modelStage,
            useCaseShortDescription: useCaseShortDescription || existingModel.useCaseShortDescription,
            created_at: created_at || existingModel.created_at,
            created_by: created_by || existingModel.created_by,
            avatar: avatar || existingModel.avatar,
            createdByName: createdByName || existingModel.createdByName,
            assessmentUuid: assessmentUuid || existingModel.assessmentUuid,
            assessmentStatus: assessmentStatus || existingModel.assessmentStatus,
            step: currentStep || existingModel.step,
            position: currentStep
              ? { ...existingModel.position, majorStep: currentStep }
              : existingModel.position || { majorStep: existingModel.step || 'useCase' },
          };
        }
      }
    
      return newState;
    }

    case UPDATE_LOADING_MESSAGE:
      return {
        ...state,
        loadingMessage: action.payload
      };

    case SET_SECTION: {
      const { modelId, sectionName } = action.payload;
      const model = state.models[modelId];

      if (!model) {
        console.error(`Model with ID ${modelId} not found.`);
        return state;
      }

      const section = model.activeSections[sectionName];
      if (!section) {
        console.error(`Section ${sectionName} not found in model ${modelId}.`);
        return state;
      }

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            currentSection: sectionName,
            activeSections: {
              ...model.activeSections,
              [sectionName]: {
                ...section
              }
            }
          }
        }
      };
    }


    // ────────────────────────────────────────────────────────
    // New area-based status management cases
    // ────────────────────────────────────────────────────────
    
    case SET_AREA_STATUS: {
      const { modelId, areaName, status } = action.payload;
      const model = state.models[modelId];
      if (!model) return state;

      const current = model.riskFormData[areaName] || {};
      
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: {
              ...model.riskFormData,
              [areaName]: {
                ...current,
                status,
                assessmentProgress: status === 'NA' || status === 'DEFERRED' ? 100 : current.assessmentProgress || 0
              }
            }
          }
        }
      };
    }

    case SET_AREA_DEFERRED: {
      const { modelId, areaName } = action.payload;
      const model = state.models[modelId];
      if (!model) return state;

      const current = model.riskFormData[areaName] || {};
      
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: {
              ...model.riskFormData,
              [areaName]: {
                ...current,
                status: 'DEFERRED',
                assessmentProgress: 100, // Mark as complete for progress tracking
                deferredAt: new Date().toISOString()
              }
            }
          }
        }
      };
    }

    case SET_AREA_NOT_APPLICABLE: {
      const { modelId, areaName } = action.payload;
      const model = state.models[modelId];
      if (!model) return state;

      const current = model.riskFormData[areaName] || {};
      
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: {
              ...model.riskFormData,
              [areaName]: {
                ...current,
                status: 'NA',
                assessmentProgress: 100, // Mark as complete for progress tracking
                markedNAAt: new Date().toISOString()
              }
            }
          }
        }
      };
    }

    case CLEAR_AREA_STATUS: {
      const { modelId, areaName } = action.payload;
      const model = state.models[modelId];
      if (!model) return state;

      const current = model.riskFormData[areaName] || {};
      
      // Remove status and timestamps, reset progress if no actual progress made
      const { status, deferredAt, markedNAAt, ...cleanedArea } = current;
      
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: {
              ...model.riskFormData,
              [areaName]: {
                ...cleanedArea,
                assessmentProgress: 0 // Reset progress when re-enabling
              }
            }
          }
        }
      };
    }

    /* ───────────────────────────────────────────────────── */
    /*  Single‑risk flow                                     */
    case SELECT_RISK_SOURCE: {
      const { modelId, riskArea, src } = action.payload;
      const model  = state.models[modelId];
      if (!model) return state;

      const area   = model.riskFormData[riskArea] || {};

      // --- update selectedSources ---
      const already = (area.selectedSources || []).some(s => s.name === src.name);
      const nextSelected = already
        ? area.selectedSources
        : [ ...(area.selectedSources || []), src ];

      // Legacy draft risk auto-creation removed - sources no longer create automatic draft risks

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: {
              ...model.riskFormData,
              [riskArea]: {
                ...area,
                selectedSources: nextSelected
                // sectionRisks no longer auto-populated - only scenarios create risks
              }
            }
          }
        }
      };
    }

    case DESELECT_RISK_SOURCE: {
      const { modelId, riskArea, srcName } = action.payload;
      const model = state.models[modelId];
      if (!model) return state;

      const area  = model.riskFormData[riskArea] || {};
      const nextSelected = (area.selectedSources || []).filter(s => s.name !== srcName);

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: {
              ...model.riskFormData,
              [riskArea]: {
                ...area,
                selectedSources: nextSelected
              }
            }
          }
        }
      };
    }

    /* ───────────────────────────────────────────────────── */
    case SET_ASSESSMENT_POSITION: {
      const { modelId, position } = action.payload;
      if (!state.models[modelId]) return state;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            position
          }
        }
      };
    }

  case CONFIG_UPDATE_SUCCESS: {
    const { name, data } = action.payload;
    console.log(`CONFIG_UPDATE_SUCCESS received for config: ${name}`);
    
    // Define which configurations affect this reducer
    const relevantConfigs = ['riskSources', 'riskRootCauses', 'riskCauseEvaluation'];
    if (!relevantConfigs.includes(name)) {
      // If the updated config doesn't affect this reducer, do nothing
      return state;
    }

    // Determine which utility function to use based on the configName
    let updatedModels = _.cloneDeep(state.models);
    Object.keys(updatedModels).forEach(modelId => {
      const existingRiskFormData = updatedModels[modelId].riskFormData;
      if (name === 'riskSources') {
        updatedModels[modelId].riskFormData = mergeRiskSources(existingRiskFormData, data);
      } else if (name === 'riskRootCauses') {
        updatedModels[modelId].riskFormData = mergeRiskRootCauses(existingRiskFormData, data);
      } else if (name === 'riskCauseEvaluation') {
        updatedModels[modelId].riskFormData = mergeRiskCauseEvaluation(existingRiskFormData, data);
      }
    });
    return {
      ...state,
      models: updatedModels,
    };
  }

    // **Configuration Update Failure**
    case CONFIG_UPDATE_FAILURE: {
      return {
        ...state,
        error: action.payload.error
      };
    }

    case SET_RISK_SOURCE: {
      const { modelId, section, source, values } = action.payload;
      const model = state.models[modelId];
      if (!model) return state;
      const sec = model.riskFormData?.[section];
      if (!sec) return state;
      const updated = sec.riskSources.map(s =>
        s.name === source ? { ...s, value: values } : s
      );
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: {
              ...model.riskFormData,
              [section]: { ...sec, riskSources: updated }
            }
          }
        }
      };
    }

case SET_ROOT_CAUSE: {
  console.log('🔍 [reducer SET_ROOT_CAUSE] payload:', action.payload);
  console.groupCollapsed('[reducer SET_FIELD]');
  console.log('action.payload:', action.payload);
  const { modelId, section, source, valueKey, path, newValue } = action.payload;
  console.log('pre-update state.riskFormData[section]:', state.models[modelId]?.riskFormData?.[section]);
  console.groupEnd();
  // Guard
  const model = state.models[modelId];
  if (!model) return state;
  const sectionData = model.riskFormData?.[section];
  if (!sectionData || !Array.isArray(sectionData.riskSources)) return state;

  // Clone the model slice we need
  const updatedRiskSources = sectionData.riskSources.map(src => {
    if (src.name !== source) return src; // only update the matching source

    // Deep-clone that source to ensure complete isolation
    const clone = _.cloneDeep(src);
    
    // Ensure the source has its own unique causesTemplate if missing
    if (!clone.causesTemplate) {
      clone.causesTemplate = _.cloneDeep(clone.causes || {});
    }
    
    // Decide the target blob:
    //  • When valueKey === null/undefined we write directly into root causes
    //  • otherwise keep the legacy per‑value bucket
    let targetBlob;
    if (valueKey == null) {
      // Ensure causes exists and is isolated from template
      if (!clone.causes) {
        clone.causes = _.cloneDeep(clone.causesTemplate);
      }
      targetBlob = clone.causes;
    } else {
      clone.causesByValue = clone.causesByValue || {};
      if (!clone.causesByValue[valueKey]) {
        // Create a completely isolated copy for this specific value
        clone.causesByValue[valueKey] = _.cloneDeep(clone.causesTemplate);
      }
      targetBlob = clone.causesByValue[valueKey];
    }

    // Traverse into the blob following `path`, then set the new value
    let node = targetBlob;
    for (let i = 0; i < path.length - 1; i++) {
      if (!node[path[i]]) node[path[i]] = {};
      node = node[path[i]];
    }
    {
      const lastKey = path[path.length - 1];
      const existing = node[lastKey];
      node[lastKey] = (existing && typeof existing === 'object')
        ? { ...existing, value: newValue }
        : { value: newValue };
    }

    return clone;
  });

  // Reassemble the section and model
  const updatedSection = {
    ...sectionData,
    riskSources: updatedRiskSources
  };

  return {
    ...state,
    models: {
      ...state.models,
      [modelId]: {
        ...model,
        riskFormData: {
          ...model.riskFormData,
          [section]: updatedSection
        }
      }
    }
  };
}

// in riskReducer.js, alongside SET_ROOT_CAUSE

case SET_DEEP_DIVE_VALUES: {
  console.log('🔍 [reducer SET_DEEP_DIVE_VALUES] payload:', action.payload);
  const { modelId, section, source, valueKey, causeCategory, deepValues } = action.payload;
  const model = state.models[modelId];
  if (!model) return state;

  const sec = model.riskFormData[section];
  if (!sec) return state;

  const updatedSources = sec.riskSources.map(src => {
    if (src.name !== source) return src;
    const clone = _.cloneDeep(src);
    
    // Ensure the source has its own unique causesTemplate
    if (!clone.causesTemplate) {
      clone.causesTemplate = _.cloneDeep(clone.causes || {});
    }
    
    if (valueKey == null) {
      // Ensure causes exists and is isolated from template
      if (!clone.causes) {
        clone.causes = _.cloneDeep(clone.causesTemplate);
      }
      if (!clone.causes[causeCategory]) {
        clone.causes[causeCategory] = {};
      }
      clone.causes[causeCategory].deepValues = deepValues;
    } else {
      clone.causesByValue = clone.causesByValue || {};
      if (!clone.causesByValue[valueKey]) {
        clone.causesByValue[valueKey] = _.cloneDeep(clone.causesTemplate);
      }
      if (!clone.causesByValue[valueKey][causeCategory]) {
        clone.causesByValue[valueKey][causeCategory] = {};
      }
      clone.causesByValue[valueKey][causeCategory].deepValues = deepValues;
    }
    return clone;
  });

  return {
    ...state,
    models: {
      ...state.models,
      [modelId]: {
        ...model,
        riskFormData: {
          ...model.riskFormData,
          [section]: { ...sec, riskSources: updatedSources }
        }
      }
    }
  };
}

case SET_DEEP_DIVE_DETAIL: {
  console.log('🔍 [reducer SET_DEEP_DIVE_DETAIL] payload:', action.payload);
  const { modelId, section, source, valueKey, causeCategory, option, detail } = action.payload;
  const model = state.models[modelId];
  if (!model) return state;

  const sec = model.riskFormData[section];
  if (!sec) return state;

  const updatedSources = sec.riskSources.map(src => {
    if (src.name !== source) return src;
    const clone = _.cloneDeep(src);
    
    // Ensure the source has its own unique causesTemplate
    if (!clone.causesTemplate) {
      clone.causesTemplate = _.cloneDeep(clone.causes || {});
    }
    
    let bucket;
    if (valueKey == null) {
      // Ensure causes exists and is isolated from template
      if (!clone.causes) {
        clone.causes = _.cloneDeep(clone.causesTemplate);
      }
      if (!clone.causes[causeCategory]) {
        clone.causes[causeCategory] = {};
      }
      bucket = clone.causes[causeCategory];
    } else {
      clone.causesByValue = clone.causesByValue || {};
      if (!clone.causesByValue[valueKey]) {
        clone.causesByValue[valueKey] = _.cloneDeep(clone.causesTemplate);
      }
      if (!clone.causesByValue[valueKey][causeCategory]) {
        clone.causesByValue[valueKey][causeCategory] = {};
      }
      bucket = clone.causesByValue[valueKey][causeCategory];
    }
    bucket.deepDetails = bucket.deepDetails || {};
    bucket.deepDetails[option] = detail;
    return clone;
  });

  return {
    ...state,
    models: {
      ...state.models,
      [modelId]: {
        ...model,
        riskFormData: {
          ...model.riskFormData,
          [section]: { ...sec, riskSources: updatedSources }
        }
      }
    }
  };
}



    case SAVE_RISK_SOURCE_START:
      return {
        ...state,
        savingRiskSource: true,
        saveRiskSourceError: null,
      };
    case SAVE_RISK_SOURCE_SUCCESS:
      return {
        ...state,
        savingRiskSource: false,
        // Optionally, handle success messages or state updates
      };
    case SAVE_RISK_SOURCE_FAILURE:
      return {
        ...state,
        savingRiskSource: false,
        saveRiskSourceError: action.payload,
      };
    case SAVE_CAUSES_START:
      return {
        ...state,
        savingCauses: true,
        saveCausesError: null,
      };
    case SAVE_CAUSES_SUCCESS:
      return {
        ...state,
        savingCauses: false,
        // Optionally, handle success messages or state updates
      };
    case SAVE_CAUSES_FAILURE:
      return {
        ...state,
        savingCauses: false,
        saveCausesError: action.payload,
      };

      // Legacy INITIALIZE_DRAFT_RISKS case removed - sources no longer auto-convert to draft risks

      case SET_CURRENT_SECTION: {
        const { modelId, sectionName } = action.payload;
        const model = state.models[modelId];
        if (!model) {
          console.error(`Model with ID ${modelId} not found.`);
          return state;
        }
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...model,
              currentSection: sectionName,
              currentSectionStep: 'riskIdentification', // Reset to initial step
            },
          },
        };
      }
  
      case SET_CURRENT_SECTION_STEP: {
        const { modelId, stepName } = action.payload;
        const model = state.models[modelId];
        if (!model) {
          console.error(`Model with ID ${modelId} not found.`);
          return state;
        }
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...model,
              currentSectionStep: stepName,
            },
          },
        };
      }
  
      case RESET_CURRENT_SECTION_STEP: {
        const { modelId } = action.payload;
        const model = state.models[modelId];
        if (!model) {
          console.error(`Model with ID ${modelId} not found.`);
          return state;
        }
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...model,
              currentSectionStep: 'riskIdentification', // Reset to initial step
            },
          },
        };
      }

      case ADD_MANUAL_RISK: {
        const { modelId, sectionName, category, riskName } = action.payload;
        const model = state.models[modelId];
        if (!model) return state;
        const section = model.riskFormData[sectionName] || {};
        const currentSectionRisks = section.sectionRisks || {};
        const categoryRisks = currentSectionRisks[category] || [];
        const newRisk = {
          riskId: uuidv4(),
          riskName,
          category,
          status: 'Draft',
          type: 'Manual',
          owner: null
        };
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...model,
              riskFormData: {
                ...model.riskFormData,
                [sectionName]: {
                  ...section,
                  sectionRisks: {
                    ...currentSectionRisks,
                    [category]: [...categoryRisks, newRisk]
                  }
                }
              }
            }
          }
        };
      }
  
  
  

    case FETCH_MODEL_RISKS_SUCCESS: {
      const { modelId, risks } = action.payload;

      console.log('Risks fetched from DB for modelId:', { risks, modelId });

      const risksBySection = risks.reduce((acc, risk) => {
        const section = risk.active_section
        const category = risk.category || 'Uncategorized'; // Default to 'Uncategorized' if no category

        if (!acc[section]) {
          acc[section] = { sectionRisks: {} };
          console.log(`Initialized section: ${section}`);
        }

        if (!acc[section].sectionRisks[category]) {
          acc[section].sectionRisks[category] = [];
          console.log(`Initialized category: ${category} under section: ${section}`);
        }

        const owner = {
          name: risk.owner_name || 'Unknown',
          email: risk.owner_email || 'Unknown',
          picture: risk.owner_picture || 'https://via.placeholder.com/150', // Default avatar
        };

        const newRisk = {
          riskId: risk.risk_id,
          riskName: risk.risk_name,
          category: risk.category,
          priority: risk.priority,
          rationale: risk.rationale,
          status: 'Saved',
          owner: owner,
          type: risk.risk_type || 'Unknown',
          rag_source_file:risk.rag_source_file,
          loading:false
        };

        // Assign risk_source only if type is 'RAG'
        if (risk.risk_type === 'RAG') {
          newRisk.rag_source_file = risk.rag_source_file || 'Unknown';
        
        };

        // Assign type
        newRisk.type = risk.risk_type || 'Unknown';

        acc[section].sectionRisks[category].push(newRisk);

        return acc;
      }, {});


      console.log('Final risksBySection structure:', risksBySection);

      const updatedModel = {
        ...state.models[modelId],
        riskFormData: {
          ...state.models[modelId].riskFormData,
          ...Object.keys(risksBySection).reduce((acc, section) => {
            acc[section] = {
              ...state.models[modelId].riskFormData[section],
              sectionRisks: {
                ...state.models[modelId].riskFormData[section]?.sectionRisks,
                ...risksBySection[section].sectionRisks,
              },
            };
            return acc;
          }, {}),
        },
      };

      console.log('Updated model state:', updatedModel.riskFormData);

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: updatedModel,
        },
      };
    }

   
    case 'risks/updateActiveSections': {
      console.log('Received updateActiveSections action:', action);
      const { modelId, sections } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            activeSections: sections,
          },
        },
      };
    }
        case SET_RISK_PRIORITY_START: {
          const { modelId, sectionName, category, riskId } = action.payload; // Ensure category is included
          return {
            ...state,
            models: {
              ...state.models,
              [modelId]: {
                ...state.models[modelId],
                riskFormData: {
                  ...state.models[modelId]?.riskFormData,
                  [sectionName]: {
                    ...state.models[modelId]?.riskFormData?.[sectionName],
                    sectionRisks: {
                      ...state.models[modelId]?.riskFormData?.[sectionName]?.sectionRisks,
                      [category]: state.models[modelId]?.riskFormData?.[sectionName]?.sectionRisks?.[category]?.map(risk =>
                        risk.riskId === riskId ? { ...risk, loading: true } : risk
                      ) || []
                    }
                  }
                }
              }
            }
          };
        }

    case SET_RISK_PRIORITY_SUCCESS: {
      const { modelId, sectionName, category, riskId, priority, rationale } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...state.models[modelId].riskFormData[sectionName],
                sectionRisks: {
                  ...state.models[modelId].riskFormData[sectionName].sectionRisks,
                  [category]: state.models[modelId].riskFormData[sectionName].sectionRisks[category]?.map(risk => {
                    if (risk.riskId !== riskId) return risk;
                    return {
                      ...risk,
                      loading: false,
                      priority: priority,
                      rationale: rationale
                    };
                  })
                }
              }
            }
          }
        }
      };
    }

    case SET_RISK_PRIORITY_FAILURE: {
      const { modelId, sectionName, category, riskId, error } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...state.models[modelId].riskFormData[sectionName],
                sectionRisks: {
                  ...state.models[modelId].riskFormData[sectionName].sectionRisks,
                  [category]: state.models[modelId].riskFormData[sectionName].sectionRisks[category]?.map(risk => {
                    if (risk.riskId !== riskId) return risk;
                    return {
                      ...risk,
                      loading: false,
                      error: error
                    };
                  })
                }
              }
            }
          }
        }
      };
    }

    case UPDATE_RISK_PRIORITY: {
      const { modelId, sectionName, category, riskId, priority } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...state.models[modelId].riskFormData[sectionName],
                sectionRisks: {
                  ...state.models[modelId].riskFormData[sectionName].sectionRisks,
                  [category]: state.models[modelId].riskFormData[sectionName].sectionRisks[category]?.map(risk => {
                    if (risk.riskId !== riskId) return risk;
                    return { ...risk, priority };
                  })
                }
              }
            }
          }
        }
      };
    }

    case DISCARD_RISKS: {
      const { modelId, sectionName, risk } = action.payload;
      const model = state.models[modelId];
      if (!model) {
        console.error("Model not found in state", modelId);
        return state;
      }

      const currentSectionRisks = model.riskFormData[sectionName].sectionRisks;

      const updatedSectionRisks = Object.keys(currentSectionRisks).reduce((acc, category) => {
        acc[category] = currentSectionRisks[category].map(r =>
          r.riskName === risk.riskName ? { ...r, status: 'Discarded' } : r
        );
        return acc;
      }, {});

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: {
              ...model.riskFormData,
              [sectionName]: {
                ...model.riskFormData[sectionName],
                sectionRisks: updatedSectionRisks
              }
            }
          }
        }
      };
    }
    case DISCARD_UNSAVED_RISKS: {
      const { risksToDiscard, modelId } = action.payload;
      const model = state.models[modelId];

      if (!model) {
        console.error(`Model with ID ${modelId} not found.`);
        return state;
      }

      // Initialize discardedRisks array if it doesn't exist
      const existingDiscardedRisks = model.discardedRisks || [];

      // Filter out the risks to discard from their original sections
      const updatedRiskFormData = { ...model.riskFormData };
      risksToDiscard.forEach((risk) => {
        Object.keys(updatedRiskFormData).forEach((section) => {
          const categories = updatedRiskFormData[section].sectionRisks;
          Object.keys(categories).forEach((category) => {
            const updatedRisks = categories[category].filter(
              (r) => r.riskName !== risk.riskName || r.status !== 'Draft'
            );
            updatedRiskFormData[section].sectionRisks[category] = updatedRisks;
          });
        });
      });

      // Avoid duplicates in discardedRisks based on riskName
      const newDiscardedRisks = [
        ...existingDiscardedRisks,
        ...risksToDiscard.filter(
          (risk) => !existingDiscardedRisks.some((discarded) => discarded.riskName === risk.riskName)
        ),
      ];

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: updatedRiskFormData,
            discardedRisks: newDiscardedRisks,
          },
        },
      };
    }
    case FETCH_RISKS_START: {
      const { modelId, sectionsToFetch } = action.payload;
      let newState = { ...state };

      if (!newState.models[modelId]) {
        console.error(`Model with ID ${modelId} not found.`);
      } else {
        if (!newState.models[modelId].sectionLoading) {
          newState.models[modelId].sectionLoading = {};
        }

        sectionsToFetch.forEach(section => {
          newState.models[modelId].sectionLoading[section] = true;
        });
      }

      return newState;
    }

    case FETCH_RISKS_FAILURE: {
      const { modelId, sectionsToFetch } = action.payload;
      let newState = { ...state };

      if (newState.models[modelId] && newState.models[modelId].sectionLoading) {
        sectionsToFetch.forEach(section => {
          newState.models[modelId].sectionLoading[section] = false;
        });
      } else {
        console.error(`Model with ID ${modelId} not found or sectionLoading not initialized.`);
      }

      return newState;
    }

    case FETCH_RISK_CARD_DATA_START: {
      const { modelId } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            loading: true,
          },
        },
      };
    }
  

 case FETCH_RISK_CARD_DATA_SUCCESS: {
      const { modelId, fetchedData } = action.payload;

      // Guard – ensure model exists
      if (!state.models[modelId]?.riskFormData) {
        console.error(`Model ID ${modelId} not found.`);
        return state;
      }

      // Work on a deep copy
      const updatedRiskFormData = _.cloneDeep(
        state.models[modelId].riskFormData
      );

      // Utility to coerce any value into a well‑formed array
      const toArray = (v) =>
        v == null ? [] : Array.isArray(v) ? v : [v];

      Object.entries(fetchedData).forEach(([riskArea, riskSources]) => {
        const area = updatedRiskFormData[riskArea];
        if (!area) return; // unknown section, skip

        // Prepare selectedSources collector for this area
        const selectedSet = new Set(area.selectedSources?.map(s => s.name));

        riskSources.forEach(({ name, value, causes, causesByValue, selected }) => {
          const src = area.riskSources.find((s) => s.name === name);
          if (!src) return; // skip sources not present in baseline config

          // Ensure each source has its own unique causesTemplate
          // Use the original template from baseline config (contains all categories)
          // Store it BEFORE we potentially overwrite src.causes with saved data
          const originalTemplate = _.cloneDeep(src.causes || {});
          src.causesTemplate = originalTemplate;
          
          console.log(`[FETCH_RISK_CARD_DATA_SUCCESS] Processing source: ${name}`, {
            hasOriginalTemplate: Object.keys(originalTemplate).length > 0,
            templateKeys: Object.keys(originalTemplate),
            hasSavedCauses: !!(causes && typeof causes === 'object'),
            savedCausesKeys: causes ? Object.keys(causes) : []
          });

          // ------------- top‑level value -------------
          src.value = toArray(value);
          // store per‑source‑value blobs so UI can address each option separately
          src.causesByValue = causesByValue || {};
          
          /* ---- Merge saved data into full template to preserve all categories ---- */
          if (causes && typeof causes === 'object') {
            // Start with full template, then merge in saved data with isolation
            src.causes = _.merge(_.cloneDeep(src.causesTemplate), _.cloneDeep(causes));
          } else {
            // If no causes from DB, use the full template
            src.causes = _.cloneDeep(src.causesTemplate);
          }
          
          // mark as selected in UI if the backend flagged it
          if (selected) selectedSet.add(name);
        });

        area.selectedSources = area.riskSources.filter(s => selectedSet.has(s.name));
      });

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: updatedRiskFormData,
          },
        },
      };
    }
  

    case FETCH_RISK_CARD_DATA_FAILURE: {
      const { modelId, error } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            error: error,
            loading: false,
          },
        },
      };
    }

    case SET_STEP: {
      const { modelId, sectionName, stepName } = action.payload;
      console.log('payload in set_step reducer', action.payload);

      if (state.models[modelId]?.riskFormData[sectionName]) {
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...state.models[modelId],
              riskFormData: {
                ...state.models[modelId].riskFormData,
                [sectionName]: {
                  ...state.models[modelId].riskFormData[sectionName],
                  currentStep: stepName  // Update the current step in the specific section
                }
              }
            }
          }
        };
      }

      console.warn(`Model with ID ${modelId} or section ${sectionName} not found.`);
      return state;
    }

    case UPDATE_ASSESSMENT_STEP_SUCCESS: {
      const { modelId, currentStep } = action.payload;
      if (state.models[modelId]) {
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...state.models[modelId],
              step: currentStep,
            }
          }
        };
      }
      console.warn(`Model with ID ${modelId} not found.`);
      return state;
    }

    case UPDATE_ASSESSMENT_STEP_FAILURE: {
      const { modelId, error } = action.payload;
      if (state.models[modelId]) {
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...state.models[modelId],
              error: error,
            },
          },
        };
      }
      console.warn(`Model with ID ${modelId} not found.`);
      return state;
    }

    case ASSESSMENT_STATUS_UPDATED: {
      const { modelId, assessmentStatus } = action.payload;
      console.log('assessment status received at reducer', action.payload);
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            assessmentStatus: assessmentStatus
          }
        }
      };
    }

    case ASSESSMENT_STATUS_FAILED: {
      const { modelId, error } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            error: error
          }
        }
      };
    }

   // In src/redux/reducers/riskReducer.js, inside your switch(action.type):

   case REFINE_RISK_START: {
    const { modelId } = action.payload;
    return {
      ...state,
      models: {
        ...state.models,
        [modelId]: {
          ...state.models[modelId],
          loading: true
        }
      }
    };
  }

case REFINE_RISK_SUCCESS: {
  console.log('[riskReducer] REFINE_RISK_SUCCESS payload:', action.payload);
  const {
    modelId,
    sectionName,
    category,
    originalName,
    refinedRisk,
    rationale,
  } = action.payload;

  const modelState = state.models[modelId];
  if (!modelState) return state;

  const sectionData = modelState.riskFormData[sectionName];
  if (!sectionData) return state;

  // update just the one risk in that category
  const updatedSectionRisks = {
    ...sectionData.sectionRisks,
    [category]: sectionData.sectionRisks[category].map(risk =>
      risk.riskName === originalName
        ? { ...risk, refinedRisk, refineRationale: rationale }
        : risk
    )
  };

  return {
    ...state,
    models: {
      ...state.models,
      [modelId]: {
        ...state.models[modelId],
        riskFormData: {
          ...state.models[modelId].riskFormData,
          [sectionName]: {
            ...state.models[modelId].riskFormData[sectionName],
            sectionRisks: updatedSectionRisks,
          }
        },
        loading: false
      }
    },
    refinedRiskDraft: { risk: refinedRisk, rationale }
  };
}

case REFINE_RISK_FAILURE: {
  const { modelId, error } = action.payload;
  return {
    ...state,
    models: {
      ...state.models,
      [modelId]: {
        ...state.models[modelId],
        loading: false,
        error
      }
    }
  };
}

    case UPDATE_RISK_NAME: {
      const { modelId, sectionName, originalName, newName } = action.payload;
      console.log('update risk in state payload:', action.payload);

      const currentSectionRisks = state.models[modelId]?.riskFormData[sectionName]?.sectionRisks;
      if (!currentSectionRisks) {
        console.error(`Section risks not found for modelId: ${modelId}, sectionName: ${sectionName}`);
        return state;
      }

      const updatedSectionRisks = Object.keys(currentSectionRisks).reduce((acc, category) => {
        acc[category] = currentSectionRisks[category].map(risk =>
          risk.riskName === originalName ? { ...risk, riskName: newName } : risk
        );
        return acc;
      }, {});

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...state.models[modelId].riskFormData[sectionName],
                sectionRisks: updatedSectionRisks
              }
            }
          }
        }
      };
    }

    case SET_RISK_EVALUATION: {
      const { modelId, riskId, themeId, evaluationData, sectionName, category } = action.payload;
      console.log('action payload in set_risk_eval reducer', action.payload);
    
      // 1) Check existence of the category array
      if (!state.models[modelId]?.riskFormData[sectionName]?.sectionRisks?.[category]) {
        console.error(`Model with ID ${modelId} or category ${category} not found or sectionRisks not initialized.`);
        return state;
      }
    
      // 2) Deep clone the models
      const updatedModels = JSON.parse(JSON.stringify(state.models));
    
      // 3) Find the target risk within that category
      const sectionRisks = updatedModels[modelId].riskFormData[sectionName].sectionRisks[category];
      const targetRisk = sectionRisks.find(risk => risk.riskId === riskId);
    
      if (targetRisk) {
        if (!targetRisk.evaluationData) {
          // Initialize evaluationData if it doesn't exist
          targetRisk.evaluationData = {};
        }
    
        // 4) If there's no entry for this themeId, init it
        if (!targetRisk.evaluationData[themeId]) {
          targetRisk.evaluationData[themeId] = {};
        }
    
        // 5) Perform a deep merge of the incoming "evaluationData" into the existing data
        targetRisk.evaluationData[themeId] = _.merge(
          {},
          targetRisk.evaluationData[themeId], // existing data
          evaluationData                      // incoming data
        );
      
    
      } else {
        console.error(`Risk with ID ${riskId} not found in category ${category}.`);
      }
    
      // 6) Return updated state
      return {
        ...state,
        models: updatedModels
      };
    }

    case UPDATE_CONTROL_IN_SELECTED_RISK: {
      const { modelId, riskName, controlData } = action.payload;
      //console.log("Reducer Payload for selected controls: ", action.payload);
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            savedRisks: state.models[modelId].savedRisks.map(risk => {
              if (risk.riskName === riskName) {
                return {
                  ...risk,
                  selectedControls: controlData
                };
              }
              return risk;
            })
          }
        }
      };
    }

  

    case UPDATE_RISK_EVALUATION: {
      const {
        modelId,
        riskId,
        sectionName,
        themeId,
        attribute,  // e.g. "riskImpact" or "likelihood"
        property,   // e.g. "overallImpact", "duration", "probability", etc.
        value,
        priority,
        rationale,
        category,
      } = action.payload;
    
      console.log('received payload in updateRiskEvaluation reducer:', action.payload);
    
      // 1) Copy the array of risks under the specified category
      const existingRisks =
        state.models[modelId]?.riskFormData[sectionName]?.sectionRisks?.[category] || [];
    
      // 2) Map over them, looking for the risk to update
      const updatedRisks = existingRisks.map((risk) => {
        if (risk.riskId !== riskId) {
          return risk; // not the correct risk
        }
    
        // 3) Copy or init evaluationData
        const evaluationData = { ...(risk.evaluationData || {}) };
        const themeEvaluation = { ...(evaluationData[themeId] || {}) };
    
        // 4) Within that theme, ensure we have an object for the attribute (e.g. "riskImpact")
        // e.g. themeEvaluation.riskImpact = { overallImpact: "Low", intensity: ... }
        if (!themeEvaluation[attribute]) {
          themeEvaluation[attribute] = {};
        }
    
        // 5) Set the property on that attribute object
        // e.g. themeEvaluation.riskImpact.overallImpact = "Moderate"
        themeEvaluation[attribute][property] = value;
    
        // Write it back
        evaluationData[themeId] = themeEvaluation;
    
        // 6) Optionally set priority, rationale
        return {
          ...risk,
          evaluationData,
          priority: priority ?? risk.priority,
          rationale: rationale ?? risk.rationale,
        };
      });
    
      // 7) Return the updated state
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...state.models[modelId].riskFormData[sectionName],
                sectionRisks: {
                  ...state.models[modelId].riskFormData[sectionName].sectionRisks,
                  [category]: updatedRisks,
                },
              },
            },
          },
        },
      };
    }

   
    case FETCH_RISK_EVALUATIONS: {
      const { modelId } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            loading: true,
            error: null,
          },
        },
      };
    }

// riskReducer.js (excerpt)

case FETCH_RISK_EVALUATIONS_SUCCESS: {
  const { modelId, evaluations, sectionName, riskEvaluationForm } = action.payload;
  const updatedModels = { ...state.models };
  const model = updatedModels[modelId];
  if (!model) return state;

  const section = model.riskFormData[sectionName];
  if (!section) return state;

  const updatedSectionRisks = { ...section.sectionRisks };

  // For each category -> risk -> merge from the DB array
  Object.keys(updatedSectionRisks).forEach((catName) => {
    updatedSectionRisks[catName] = updatedSectionRisks[catName].map((risk) => {
      const newEvaluationData = { ...risk.evaluationData };
      // We'll match by (riskId, themeId)
      evaluations.forEach((dbEval) => {
        // Instead of checking `&& dbEval.theme_id === risk.themeId`
        // we only check if the riskId matches
        if (dbEval.risk_id === risk.riskId) {
          const themeId = dbEval.theme_id;
          newEvaluationData[themeId] = newEvaluationData[themeId] || {};
      
          // Use evaluation form from action payload (passed from action)
          const evaluationFormFromConfigs = riskEvaluationForm || [];
          console.log('[Reducer] FETCH_RISK_EVALUATIONS_SUCCESS mapping:', {
            themeId,
            dbEval,
            evaluationFormFromConfigs: evaluationFormFromConfigs.length,
            configFromPayload: !!riskEvaluationForm,
            configLength: riskEvaluationForm?.length
          });
          
          if (evaluationFormFromConfigs.length === 0) {
            // Error: Config should always be available via action payload
            console.error('[Reducer] riskEvaluationForm config not available in action payload. Cannot map evaluation data without config.');
            // Skip this evaluation instead of using hardcoded fallback
            return;
          } else {
            evaluationFormFromConfigs.forEach((criterion) => {
              const attr = criterion.attribute;
              if (!newEvaluationData[themeId][attr]) {
                newEvaluationData[themeId][attr] = {};
              }
              // baseEval
              const baseKey = criterion.baseEvaluation.name;
              newEvaluationData[themeId][attr][baseKey] = dbEval[baseKey] || '';
              // deepDive
              criterion.deepDive.forEach((field) => {
                newEvaluationData[themeId][attr][field.name] = dbEval[field.name] || '';
              });
            });
          }
        }
      });
      return { ...risk, evaluationData: newEvaluationData };
    });
  });

  updatedModels[modelId].riskFormData[sectionName].sectionRisks = updatedSectionRisks;
  return { ...state, models: updatedModels };
}

    case FETCH_RISK_EVALUATIONS_FAILURE: {
      const { modelId, error } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            loading: false,
            error,
          },
        },
      };
    }

   

    case UPDATE_ACTIVE_SECTIONS_FROM_SAVED_RISKS: {
      const { modelId, uniqueSections } = action.payload;
      console.log('action payload in act sec reducer', action.payload);

      if (state.models[modelId]) {
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...state.models[modelId],
              activeSections: uniqueSections,
            },
          },
        };
      }

      console.warn(`Model with ID ${modelId} not found.`);
      return state;
    }

    case MOVE_SCENARIO_TO_RISKS: {
      const { modelId, riskArea, sourceName, scenario, owner } = action.payload;
      const model = state.models[modelId];
      if (!model) return state;

      /* ensure we are working with initialised structures */
      const area               = model.riskFormData[riskArea] || {};
      const currentSectionRisks = area.sectionRisks || {};

      /* always keep/assign a stable riskId */
      const riskId = scenario.scenarioId || uuidv4();

      /* build a fully‑fledged Risk object */
      const newRisk = {
        riskId,
        riskName : scenario.scenarioText || scenario.variantText || '',
        category : sourceName,
        status   : 'Saved',            // ← directly saved
        type     : 'Scenario',         // identify provenance
        rationale: scenario.rationale || '',
        owner    : owner || null,
      };

      /* append (deduping on riskId) */
      const updatedCategoryRisks = [
        ...(currentSectionRisks[sourceName] || []).filter(r => r.riskId !== riskId),
        newRisk
      ];

      const nextSectionRisks = {
        ...currentSectionRisks,
        [sourceName]: updatedCategoryRisks
      };

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...model,
            riskFormData: {
              ...model.riskFormData,
              [riskArea]: {
                ...area,
                sectionRisks: nextSectionRisks
              }
            }
          }
        }
      };
    }
    case MOVE_RISK_TO_SAVED: {
      const { modelId, sectionName, risk } = action.payload;
      const section = state.models[modelId].riskFormData[sectionName];
      const cat = risk.category;
      // 1) Add/update the saved item
      const savedList = [
        ...(section.sectionRisks[cat] || []).filter(r => r.riskId),
        { ...risk, status: 'Saved' }
      ];
      // 2) Drop the old draft(s)
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...section,
                sectionRisks: {
                  ...section.sectionRisks,
                  [cat]: savedList
                }
              }
            }
          }
        }
      };
    }

    case UPDATE_SAVED_RISK: {
      const { modelId, sectionName, riskId, category, newDetails } = action.payload;
console.log ('props received in update saved risk', action.payload)
      if (!state.models[modelId] || !state.models[modelId].riskFormData[sectionName]) {
        console.error(`No model with ID ${modelId} or section ${sectionName} exists.`);
        return state;
      }

      const sectionRisks = {
        ...state.models[modelId].riskFormData[sectionName].sectionRisks,
      };

      if (!sectionRisks[category]) {
        sectionRisks[category] = [];
      }

      sectionRisks[category] = sectionRisks[category].map((risk) =>
        risk.riskId === riskId ? { ...risk, ...newDetails } : risk
      );

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...state.models[modelId].riskFormData[sectionName],
                sectionRisks,
              },
            },
          },
        },
      };
    }

    case DISCARD_SAVED_RISK: {
      const { riskId, modelId, sectionName } = action.payload;
      const currentModel = state.models[modelId];
      if (!currentModel) {
        console.error(`Model with ID ${modelId} not found.`);
        return state;
      }

      const sectionRisks = { ...currentModel.riskFormData[sectionName].sectionRisks };

      Object.keys(sectionRisks).forEach(category => {
        sectionRisks[category] = sectionRisks[category].map(risk =>
          risk.riskId === riskId ? { ...risk, status: 'Discarded' } : risk
        );
      });

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...currentModel,
            riskFormData: {
              ...currentModel.riskFormData,
              [sectionName]: {
                ...currentModel.riskFormData[sectionName],
                sectionRisks,
              }
            }
          }
        }
      };
    }

    case FETCH_SECTION_SPECIFIC_RISKS_START: {
      const { modelId, sectionName } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            sectionLoading: {
              ...state.models[modelId].sectionLoading,
              [sectionName]: true,
            },
          },
        },
      };
    }

   

    case FETCH_SECTION_SPECIFIC_RISKS_SUCCESS: {
      const { modelId, sectionName, risks } = action.payload;
      console.log('Draft risks to enter into state', risks);

      // Get the existing risks in this section
      const existingRisks = state.models[modelId]?.riskFormData[sectionName]?.sectionRisks || {};

      // Process the new risks, merging them with existing risks
      const updatedRisks = Object.entries(risks).reduce((acc, [category, risksArray]) => {
        // Combine new risks with existing ones for each category
        acc[category] = [
          ...(existingRisks[category] || []).filter(risk => risk.status !== 'Generated'), // Preserve non-generated risks
          ...risksArray.map(risk => ({
            ...risk,
            status: risk.status || 'Generated', // Ensure each new risk has a 'Generated' status
            riskName: risk.riskName,
            category: risk.category,
            causes: risk.causes,
            type:risk.type, 
            rag_source_file: risk.rag_source_file || 'Unknown', // Assign sourceFile if available
          }))
        ];
        return acc;
      }, {});

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...state.models[modelId].riskFormData[sectionName],
                sectionRisks: updatedRisks,
              },
            },
            sectionLoading: {
              ...state.models[modelId].sectionLoading,
              [sectionName]: false,
            },
          },
        },
      };
    }

    case FETCH_SECTION_SPECIFIC_RISKS_FAILURE: {
      const { modelId, sectionName, error } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            sectionLoading: {
              ...state.models[modelId].sectionLoading,
              [sectionName]: false,
            },
            error,
          },
        },
      };
    }

    case REFRESH_RISKS_SUCCESS: {
      const { modelId, sectionName, categorizedRisks } = action.payload;
      const existingRisks = state.models[modelId]?.riskFormData[sectionName]?.sectionRisks || {};

      const updatedRisks = { ...existingRisks };

      Object.entries(categorizedRisks).forEach(([category, risksArray]) => {
        updatedRisks[category] = [
          ...(existingRisks[category] || []).filter(risk => risk.status !== 'Generated'), // Preserve non-generated risks
          ...risksArray.map(risk => ({
            ...risk,
            status: risk.status || 'Generated',
            riskName: risk.riskName,
          }))
        ];
      });

      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...state.models[modelId].riskFormData[sectionName],
                sectionRisks: updatedRisks,
              },
            },
            sectionLoading: {
              ...state.models[modelId].sectionLoading,
              [sectionName]: false,
            },
          },
        },
      };
    }

    case UPDATE_SECTION_PROGRESS: {
      const { modelId, sectionName, progress } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskFormData: {
              ...state.models[modelId].riskFormData,
              [sectionName]: {
                ...state.models[modelId].riskFormData[sectionName],
                assessmentProgress: progress,  // Store progress directly in the section
              },
            },
          },
        },
      };
    }
        /* ─────────────────────────────────────────────────────────────
       Source-level tracking for AssessmentStepperV2
       ───────────────────────────────────────────────────────────── */
       case REGISTER_RISK_SOURCES: {
        const { modelId, riskArea, names } = action.payload;
        const model = state.models[modelId];
        if (!model) return state;
  
        const area  = model.riskFormData?.[riskArea] || {};
        const fresh = names.map(n => ({ name:n, selected:false, progress:0 }));
  
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...model,
              riskFormData: {
                ...model.riskFormData,
                [riskArea]: { ...area, riskSources: fresh }
              }
            }
          }
        };
      }
  
      case TOGGLE_RISK_SOURCE: {
        const { modelId, riskArea, srcName } = action.payload;
        const model = state.models[modelId];
        if (!model) return state;
  
        const area  = model.riskFormData?.[riskArea];
        if (!area || !Array.isArray(area.riskSources)) return state;
  
        const next = area.riskSources.map(s =>
          s.name === srcName ? { ...s, selected: !s.selected } : s);
  
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...model,
              riskFormData: {
                ...model.riskFormData,
                [riskArea]: { ...area, riskSources: next }
              }
            }
          }
        };
      }
  
      case SET_RISK_SOURCE_PROGRESS: {
        const { modelId, riskArea, srcName, progress } = action.payload;
        const model = state.models[modelId];
        if (!model) return state;
  
        const area  = model.riskFormData?.[riskArea];
        if (!area || !Array.isArray(area.riskSources)) return state;
  
        const next = area.riskSources.map(s =>
          s.name === srcName ? { ...s, progress } : s);
  
        return {
          ...state,
          models: {
            ...state.models,
            [modelId]: {
              ...model,
              riskFormData: {
                ...model.riskFormData,
                [riskArea]: { ...area, riskSources: next }
              }
            }
          }
        };
      }

    case GENERATE_RISK_NARRATIVE_START: {
      const { modelId, riskId } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskNarratives: {
              ...state.models[modelId].riskNarratives,
              [riskId]: { loading: true, text: null, error: null }
            }
          }
        }
      };
    }
    case GENERATE_RISK_NARRATIVE_SUCCESS: {
      const { modelId, riskId, narrative } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskNarratives: {
              ...state.models[modelId].riskNarratives,
              [riskId]: { loading: false, text: narrative, error: null }
            }
          }
        }
      };
    }
    case GENERATE_RISK_NARRATIVE_FAILURE: {
      const { modelId, riskId, error } = action.payload;
      return {
        ...state,
        models: {
          ...state.models,
          [modelId]: {
            ...state.models[modelId],
            riskNarratives: {
              ...state.models[modelId].riskNarratives,
              [riskId]: { loading: false, text: null, error }
            }
          }
        }
      };
    }

    default:
      return state;
  }

}

export default riskReducer;
